var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richtext"},[_c('textarea',{attrs:{"id":"editor","rows":_vm.ckeRows,"cols":_vm.ckeCols}})])}
var staticRenderFns = []

export { render, staticRenderFns }